import { linkTables } from '../data/links';

export function LinkPage() {
  return (
    <>
      <div className="hero">
        <h1>リンク集</h1>
        <p>
          コメントやリンクそのものに問題がある場合は、連絡頂ければ直ぐに対応いたします。
          何卒宜しくお願いします。重複を厭わずに書いている為め、何度も登場するサイトもあります。
        </p>
      </div>
      {linkTables.map((table) => (
        <section className="card" key={table.title}>
          <h2>{table.title}</h2>
          <div className="table-scroll">
            <table className="link-table">
              <thead>
                <tr>
                  {table.headers.map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {table.rows.map((row, i) => (
                  <tr key={`${row.url}-${i}`}>
                    <td>
                      <a href={row.url} target="_blank" rel="noreferrer">
                        {row.name}
                      </a>
                    </td>
                    <td>{row.col2}</td>
                    <td>{row.col3}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      ))}
    </>
  );
}
